// extracted by extract-css-chunks-webpack-plugin
module.exports = {"m-notification":"m-notification___3pqZr","m-notification--visible":"m-notification--visible___1BCLU"};